import React from 'react';

class SubSeasonsDropdown extends React.Component {

  constructor(props) {
		super(props);
		this.subSeasonChange = this.subSeasonChange.bind(this);
		this.createSelectItem = this.createSelectItem.bind(this);
	}

	subSeasonChange(event) {
		var subSeasonId = event.target.value;
		this.props.subSeasonChange(subSeasonId);
	}

	render() {
		//console.log('SubSeasonsDropdown: render')
		var subSeasons = [];
		if (this.props.subSeasons) {
			subSeasons = this.props.subSeasons;
		}

		return (
			<select className="form-control" value={this.props.value} onChange={this.subSeasonChange}>
				{subSeasons.map(this.createSelectItem)}
			</select>
		);
	}

	createSelectItem(subSeason) {
		return (
			<option value={subSeason.id} key={"ss" + subSeason.id}>{subSeason.name}</option>
		);
	}

}

export default SubSeasonsDropdown;